import * as Customers from './customers';
import * as Users from './users';

export { Customers, Users };
